// src/store/actions/refreshIfNeeded.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { addAuth } from "../slices/authSlice";

const BASE = (process.env.REACT_APP_SERVER_URL || "").replace(/\/+$/, "");
const REFRESH_URL = `${BASE}/users/accesstoken`;

// single in-flight guard
let inflight = null;

// skew: token ke expire hone se ~60s pehle hi refresh
export const refreshIfNeeded = (skewSeconds = 60) => async (dispatch, getState) => {
  try {
    const at = localStorage.getItem("accessToken");
    const rt = localStorage.getItem("refreshToken");
    if (!rt) return false; // guest

    // Decide if refresh needed
    let need = false;
    try {
      if (!at) need = true;
      else {
        const { exp } = jwtDecode(at);
        const now = Math.floor(Date.now() / 1000);
        need = !exp || (exp - now) <= skewSeconds; // expiring soon or expired
      }
    } catch {
      need = true;
    }
    if (!need) return false;

    // already refreshing → wait & reuse
    if (inflight) return inflight;

    inflight = (async () => {
      try {
        // --- Variant A: body me refreshToken (pehle ye try karo) ---
        const res = await axios.post(REFRESH_URL, { refreshToken: rt });

        // --- Agar yahan 401 milta rahe to Variant B use karo:
        // const res = await axios.post(REFRESH_URL, {}, {
        //   headers: { Authorization: `Bearer ${rt}` }
        // });

        const data = res?.data || {};
        const details = data.details || {};
        const newAT = details.accessToken ?? data.accessToken ?? data.token;
        const newRT = details.refreshToken ?? data.refreshToken ?? rt;

        if (!newAT) throw new Error("No access token in refresh response");

        localStorage.setItem("accessToken", newAT);
        localStorage.setItem("refreshToken", newRT);

        // optional: auth slice ko update kar do
        const prev = getState().auth || {};
        dispatch(addAuth({ ...prev, accessToken: newAT, refreshToken: newRT }));

        return true; // refreshed
      } catch (e) {
        // refresh fail → clean logout
        localStorage.clear();
        try { window.location.replace("/login"); } catch {}
        throw e;
      } finally {
        inflight = null;
      }
    })();

    return await inflight;
  } catch (e) {
    // swallow here; callers generally normal API karenge
    return false;
  }
};
